document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-info-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var modalId = btn.getAttribute('data-modal-id');
      // Support both modalProductInfo-01 and modalProductInfo1
      var modal = document.getElementById(modalId) || document.getElementById(modalId.replace(/(\d+)$/, '-0$1'));
      if (modal) {
        modal.style.display = 'block';
        modal.classList.add('show');
        modal.classList.add('fade');
        document.body.style.overflow = 'hidden';
        // Optionally add backdrop
        if (!document.querySelector('.modal-backdrop')) {
          var backdrop = document.createElement('div');
          backdrop.className = 'modal-backdrop fade show';
          document.body.appendChild(backdrop);
          // Add click event to backdrop to close modal
          backdrop.addEventListener('click', function() {
            modal.style.display = 'none';
            modal.classList.remove('show');
            document.body.style.overflow = '';
            var backdropElem = document.querySelector('.modal-backdrop');
            if (backdropElem) backdropElem.remove();
          });
        }
        // Close on .close button click
        var closeBtn = modal.querySelector('.close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            modal.style.display = 'none';
            modal.classList.remove('show');
            document.body.style.overflow = '';
            var backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) backdrop.remove();
          }, { once: true });
        }
      }
    });
  });
});

(() => {
  const cardSelector = 'product-card.product-card';
  const observedLists = new Map();
  let frame;

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(alignRows);
  };

  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (observedLists.get(entry.target) !== width) {
        observedLists.set(entry.target, width);
        schedule();
      }
    }
  });

  function alignRows() {
    frame = null;
    const lists = new Map();
    const cards = Array.from(document.querySelectorAll(cardSelector));

    for (const card of cards) {
      card.style.removeProperty('--hoya-card-title-height');
      card.style.removeProperty('--hoya-card-price-height');
      if (!card.offsetWidth) continue;
      const title = card.querySelector('.product-card__info .product-title');
      const price = card.querySelector('.product-card__info .price-list');
      if (!title?.getClientRects().length) continue;
      const list = card.parentElement;
      if (!lists.has(list)) lists.set(list, []);
      lists.get(list).push({ card, title, price });
    }

    for (const [list, items] of lists) {
      if (!observedLists.has(list)) {
        observedLists.set(list, list.getBoundingClientRect().width);
        resizeObserver.observe(list);
      }
      const rows = [];
      for (const item of items) {
        const top = item.card.offsetTop;
        let row = rows.find(candidate => Math.abs(candidate.top - top) < 2);
        if (!row) {
          row = { top, items: [] };
          rows.push(row);
        }
        row.items.push(item);
      }
      for (const row of rows) {
        const titleHeight = Math.max(...row.items.map(item => item.title.getBoundingClientRect().height));
        const priceHeight = Math.max(...row.items.map(item => item.price?.getBoundingClientRect().height || 0));
        for (const { card } of row.items) {
          card.style.setProperty('--hoya-card-title-height', `${titleHeight}px`);
          card.style.setProperty('--hoya-card-price-height', `${priceHeight}px`);
        }
      }
    }

    for (const list of observedLists.keys()) {
      if (!list.isConnected) {
        resizeObserver.unobserve(list);
        observedLists.delete(list);
      }
    }
  }

  const affectsCards = node => node.nodeType === 1 && (
    node.matches(cardSelector) || node.closest(cardSelector) || node.querySelector(cardSelector)
  );

  new MutationObserver(records => {
    if (records.some(record => affectsCards(record.target) ||
      Array.from(record.addedNodes).some(affectsCards) ||
      Array.from(record.removedNodes).some(affectsCards))) schedule();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden', 'collection-mobile-layout', 'collection-desktop-layout']
  });

  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  schedule();
})();
